import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TransportOrderIdView } from '../../../models';
import { Store } from '@ngxs/store';
import {
  ShipmentTransportOrderItemNotificationListCountLoad,
  ShipmentTransportOrderItemSetIdentifier,
  ShipmentTransportOrderItemSetInitial,
} from './shipment-transport-order-item.actions';
import { ShipmentTransportOrderItemState } from './shipment-transport-order-item.state';

@Injectable({ providedIn: 'root' })
export class ShipmentTransportOrderItemFacade {
  shipmentTransportOrderIdentifier$: Observable<TransportOrderIdView> = this.store.select(
    ShipmentTransportOrderItemState.getShipmentTransportOrderIdentifier,
  );

  notificationListCount$: Observable<number> = this.store.select(
    ShipmentTransportOrderItemState.getShipmentTransportOrderHasNotification,
  );

  loaded$: Observable<boolean> = this.store.select(ShipmentTransportOrderItemState.getLoaded);

  constructor(private store: Store) {}

  setShipmentTransportOrderIdentifier(identifier: TransportOrderIdView): void {
    this.store.dispatch(new ShipmentTransportOrderItemSetIdentifier(identifier));
  }

  loadShipmentTransportOrderNotificationListCount(identifier: TransportOrderIdView): void {
    this.store.dispatch(new ShipmentTransportOrderItemNotificationListCountLoad(identifier));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentTransportOrderItemSetInitial());
  }
}
